
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
        <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.title}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag @click="playUrl=  record.url" color="green">试听</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
          <a @click="handleSubjecType(record)">相关项目配置</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>

        </template>
      </span>
    </s-table>


    <div style="position: fixed; bottom: 0px;border-radius: 10px;background: #fff; z-index: 10" v-if="playUrl" >
      <audio autoplay	 style="margin: 20px" :src="playUrl" controls="controls"></audio>
      <a-icon type="close"  @click="playUrl = ''" style="position: absolute; top: 5px; right: 5px;font-size: 22px; cursor: pointer; z-index: 20"/>
    </div>

    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'title',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="音乐"
                      hasFeedback
              >

                  <file-uploader
                          :file-list="formData.att"
                          accept=".mp3"
                          :numberLimit="1"
                  />              </a-form-item>
            </a-col>
          </a-row>
 

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="管理项目配置"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="subjectTypeVisible"
            @ok="subjectTypeVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table
                  :columns="subjectTypeColumns" :dataSource="subjectTypeList" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              {{record.name}}
            </span> 
            <template slot="action" slot-scope="text,record,index">
                <a href="javascript:;" @click="handleSubjectSetting(record,index)">配置</a>
             <a-divider type="vertical" />
              <a-popconfirm title="确定取消该项目配置下的所有关联信息吗" @confirm="deleteSubjectType(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
                <a-select  style="width: 600px; margin-right: 10px;" 
                    showSearch
                    optionFilterProp="name" v-model="musicData.typeid" placeholder="请选择项目配置"  >
                <a-select-option :name="op.id+'|'+op.name" :key='oi' :value="op.id" v-for="(op,oi) in subjectTypeOption">[ID:{{op.id}}]{{op.name}}</a-select-option> 
                </a-select>
                <a-button icon="plus" @click="addSubjectType" >新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="项目配置"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="subjectTreeVisible"
            @ok="subjectTreeVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">  
          <a-table
                  :columns="subjectTreeColumns"
                  :dataSource="subjectTreeList"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
          >
           <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="subjectTreeQuery.keywords"
                      placeholder="搜索项目"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="subjectTreeSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="subjectTreeSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            
        <span slot="music" slot-scope="text,record">
          <template >
              <r-switch :formData="record" @change="musicCheckedChange(record)" field="music_checked" :checkedValue="1" :unCheckedValue="2"
                        checkedChildren="是" unCheckedChildren="否"/>
          </template>
        </span> 
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaijiList ,getSaijiDetail,editSaiji ,getMusicSubjectTypeList,getSubjectTypeMusicTree,
  subjectMusicList,subjectMusicDetail,editSubjectMusic,subjectMusicDelete,addSubjectMusic,subjectTypeOption
  ,getSubjectMusicTreeList,setSubjectMusic,deleteSubjectTypeMusic } from '@/api/sai'
  export default {
    name: 'KaojiSaijiList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
                areaOptions,
                playUrl:'',
                visible: false,
                saveLoading:false,
                formData:{
                  id:0,
                  status:1,
                    att:[]
                },
                saijiOptions:[],
                labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 12 },
                },
                form: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {
                  keywords:'',
                },
                // 表头
                columns: [
                  {
                    title: '#',
                    dataIndex: 'id',
                    width: '50px'
                  },
                  {
                    title: '名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                  },
                  {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                  },
                  {
                    title: '操作',
                    dataIndex: 'action',
                    fixed: 'right',
                    width: 300,
                    scopedSlots: { customRender: 'action' },
                  }
                ],
                subjectTypeVisible:false, 

                //项目配置表头
                subjectTypeColumns: [
                  {
                    title: '#',
                    dataIndex: 'id',
                    width: '50px'
                  },
                  {
                    title: '项目配置名称',
                    dataIndex: 'title',
                    scopedSlots: { customRender: 'name' },
                  }, 
                  {
                    title: '操作',
                    dataIndex: 'action',
                    width: '150px',
                    scopedSlots: { customRender: 'action' },
                  }
                ],
                subjectTypeList:[],
                subjectTypeKeywords: '',
                
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                          console.log('loadData');
                  console.log(this.queryParam);
                  let that= this;


                  this.queryParam = Object.assign(this.queryParam,parameter);
                  return subjectMusicList(this.queryParam)
                                  .then(res => {
                            console.log('res');
                  return res.data
                })
                },

                selectedRowKeys: [],
                selectedRows: [],
                cashFormData:{
                          ids:[],
                          to_type:'',
                          price:0,
                          note:'',
                          count:0,
                },
                musicData:{

                },
                subjectTypeOption:[],
                subjectTreeVisible:false,
                subjectTreeColumns: [
                  {
                    title: '组别/项目',
                    dataIndex: 'name',
                    scopedSlots: {
                      filterDropdown: 'filterDropdown',
                      filterIcon: 'filterIcon',
                      customRender: 'name',
                    }
                  },
                  {
                    title: '关联音乐',
                    width: '150px',
                    dataIndex: 'music',
                    scopedSlots: { customRender: 'music' },
                  }, 
                ],
                subjectTreeQuery: {
                  typeid: 0,
                  music_id:0
                }, 
              subjectTreeList: [],
    }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSubjectTypeOption();
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      getSubjectTypeOption(){ 
        let that = this;
        subjectTypeOption({  }).then(res => {
          that.subjectTypeOption = res.data
      })
      },
    addHandle(){
        this.formData ={
            id:0,
            att:[],
        }
        this.form.resetFields();
        this.visible = true
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        subjectMusicDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
          self.form.setFieldsValue({ ...res.data })
          self.formData.id = record.id;
          console.log('handleEdit')
          self.formData = { ...res.data };
        },200)
      })
        // console.log(this.mdl)
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
          if(self.formData.att.length==0){
              self.$message.error('请上传音乐');
              return ;
          }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
              if(self.formData.id>0){
                  editSubjectMusic({
                      id:self.formData.id,
                      title:values.title,
                      att:self.formData.att,
                  }).then(res => {
                      self.$message.success('修改成功')
                      self.$refs.table.refresh(false)
                      self.visible = false;
                      self.saveLoading = false;
                  }).catch(err =>{
                      self.$message.error(err.data.msg);
                      self.saveLoading = false;
                  })
              }else{
                  addSubjectMusic({
                      title:values.title,
                      att:self.formData.att,
                  }).then(res => {
                      self.$message.success('新增成功')
                      self.$refs.table.refresh(false)
                      self.visible = false;
                      self.saveLoading = false;
                  }).catch(err =>{
                      self.$message.error(err.data.msg);
                      self.saveLoading = false;
                  })
              }
          }
        })
      },

        // 删
        deleteHandle(record) {
            let self = this
            subjectMusicDelete({ id: record.id }).then(res => {
                self.$message.success('删除成功')
                self.$refs.table.refresh(false)
            }).catch(err =>{
                self.$message.error(err.data.msg)
            })
        },

      handleSubjecType(record) {
        let self = this
        self.musicData.music_id = record.id;
        self.getSubecjtTypeList();

        this.subjectTypeVisible = true
      },

      getSubecjtTypeList(){
        let self = this
        getMusicSubjectTypeList({music_id: self.musicData.music_id}).then(res => {
          self.subjectTypeList = res.data
        })
      },

      addSubjectType(){
        let self = this;
        if(!self.musicData.typeid){
          self.$message.error('请选择项目');
          return ;
        }
        this.handleSubjectSetting({
          id:self.musicData.typeid
        });
      },
      handleSubjectSetting(record){
        let that = this
        that.subjectTreeVisible = true
        that.subjectTreeQuery.music_id = that.musicData.music_id
        that.subjectTreeQuery.typeid = record.id
        this.fetchSubjectTreeList()

      },
      deleteSubjectType(record,index){
        let self = this;
        deleteSubjectTypeMusic({
          music_id:self.musicData.music_id,
          typeid:record.id,
        }).then(res => {
          self.$message.success('删除成功') 
          self.getSubecjtTypeList()
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },


      fetchSubjectTreeList() {
        let self = this
        self.saveLoading = true;
        getSubjectMusicTreeList(self.subjectTreeQuery).then(res => {
          self.subjectTreeList = res.data
          self.saveLoading = false;
        })
      },


      subjectTreeSearch(selectedKeys,confirm){
        let self = this
        confirm();
        // console.log('self.subjectTreeQuery',self.subjectTreeQuery);return;
        self.fetchSubjectTreeList();
      },
      subjectTreeSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.subjectTreeQuery.keywords = undefined;
        self.fetchSubjectTreeList();
      },
      musicCheckedChange(record){
        console.log('musicCheckedChange',record)
        let that = this;
        let music_id = record.music_checked==1? that.musicData.music_id:0;
        setSubjectMusic({
          typeid: that.subjectTreeQuery.typeid,
          subject: record.key,
          music_id:music_id
        }).then(res => {
          that.fetchSubjectTreeList()
          that.getSubecjtTypeList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })

      },


      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
